require('./broadcastManagerController');
require('../../schedule/scheduleDirective');
require('../../shared/graphicOverlay/graphicOverlayDirective');
require('../../shared/gameInfo/gameInfoDirective');

'use strict';

angular.module('app.admin.broadcastManager', [
  'app.admin.broadcastManager.broadcastManagerController',
  'app.shared.graphicOverlay.graphicOverlayDirective',
  'app.shared.gameInfo.gameInfoDirective',
])
    .config([
      '$stateProvider',
      function ($stateProvider) {
        $stateProvider.state('app.admin.broadcastManager', {
          url: '/broadcast_manager?:gameId',
          templateUrl: 'components/admin/broadcastManager/broadcastManagerView.html',
          controller: 'app.admin.broadcastManager.broadcastManagerController',
          title: 'Broadcast Manager'
        });
      }
    ]);



// WEBPACK FOOTER //
// ./app.v2/components/admin/broadcastManager/broadcastManager.js